import useAuth from '../../hooks/utils/useAuth';
import { useTrustedSignup } from '../../hooks/api/useTrustedSignup';
import { useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { InlineSpinner } from '../../components/common/spinner';
import { useHistory } from 'react-router-dom';
import { ROUTE_PATH } from '../../routes/route-paths';

const TrustedSignup: React.FC = () => {
  const history = useHistory();
  const { authToken } = useAuth();
  const { trustedSignup } = useTrustedSignup();
  const { packageCode } = useParams<{ packageCode: string }>();
  const isFirstRun = useRef(false);

  useEffect(() => {
    if (!packageCode) {
      history.push(ROUTE_PATH.LANDING_PAGE);
      return;
    }

    if (authToken && packageCode && !isFirstRun.current) {
      isFirstRun.current = true;
      trustedSignup.mutate(
        { token: authToken, packageCode: packageCode },
        {
          onSuccess: () => {
            history.push(ROUTE_PATH.HOME);
          },
          // TODO: this is a hack — we're getting a potential race condition 500 error from keycloak on a second attempt, but let's send them home anyway  for now since the user exists and belongs.
          onError: (error) => {
            history.push(ROUTE_PATH.HOME);
          },
        },
      );
    }
  }, [authToken, trustedSignup, packageCode, history]);

  return <InlineSpinner />;
};

export default TrustedSignup;
